const companyUserTypes = {
  LOADING: "loading",
  COMPANY_USER_LIST: "companyUser/getAllCompanyUser",
  SAVE_OR_UPDATE_COMPANY: "companyUser/saveOrUpdateCompanyUser",
  DELETE_COMPANY_USERID: "companyUser/deleteCompanyUserById",
  COMPANY_USER_DETAILS: "companyUser/getCompanyUserDetailsById",
};

export default companyUserTypes;
